import { Palette, Share2, Link2, Send, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";

const steps = (square) => [
  [Palette, "Choose your design", "Pick a style above and edit the title or what's shown."],
  [Share2, "Press Share or Download", "The picture is saved and your personal link is copied for you."],
  square
    ? [Link2, "Add your link", "Facebook: paste it in the post text. Instagram feed posts can't have links — paste it in your bio or caption."]
    : [Link2, "Add a Link sticker", "In your Instagram or Facebook story, tap the sticker icon → Link → paste. Place it over the \"See my bucket list\" button."],
  [Send, "Post it", "Friends tap the link to see your list and make their own bucket list."],
];

export const HowToPost = ({ square, onCopy }) => (
  <div className="rounded-xl border border-emerald-400/25 bg-emerald-400/[0.05] p-4" data-testid="story-sticker-tip">
    <div className="flex items-center justify-between gap-2 mb-3">
      <p className="text-sm font-medium text-emerald-200">How to post it</p>
      <Button size="sm" variant="outline" className="h-7 bg-transparent text-xs" onClick={onCopy} data-testid="story-copy-sticker-link">
        <Copy size={12} /> Copy link again
      </Button>
    </div>
    <ol className="space-y-3">
      {steps(square).map(([Icon, title, text], i) => (
        <li key={title} className="flex gap-3" data-testid={`story-step-${i + 1}`}>
          <span className="shrink-0 w-7 h-7 rounded-full bg-emerald-400/15 text-emerald-300 grid place-items-center text-xs font-semibold">{i + 1}</span>
          <span className="min-w-0">
            <span className="flex items-center gap-1.5 text-sm text-slate-100"><Icon size={13} className="text-emerald-300" /> {title}</span>
            <span className="block text-xs text-slate-400 mt-0.5 leading-relaxed">{text}</span>
          </span>
        </li>
      ))}
    </ol>
  </div>
);
